import React from "react";
import "../../../../App.css";
import SideBar from "components/layout/sidebar/Sidebar";
import DashboardNavBar from "components/layout/DashboardNavBar";
import AllowanceReasonForm from "./AllowanceReasonForm";

const CallNewAllowanceReason = ({ match }) => {

    return (
        <div>
            <DashboardNavBar />
            <SideBar />
            <AllowanceReasonForm context={"new"} />
        </div>
    );
}

export default CallNewAllowanceReason;